module.exports = __webpack_public_path__ + "img/70.0245c899.jpg";